import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { createBrowserHistory } from 'history';

// Auth redux actions
import { authErrorAction, loginSuccessAction, logoutSuccessAction } from '~/store/actions.js';

// API calls
import { api_facebookLogin, api_googleLogin, api_login, api_logout } from '~/backend/api_calls';

// User object via local store
import { t } from 'i18next';
import UserSession from '~/backend/user_session';

function* loginCustomer(action) {
	try {
		const response = yield call(api_login, action.args);

		UserSession.initWithJson(response);

		yield put(loginSuccessAction(response, 'Welcome back ' + UserSession.getName()));

		// Goto profile page after successful login
		//createBrowserHistory().push("/profile");
		//window.location.reload();
	} catch (error) {
		yield put(authErrorAction(error));
	}
}

function* GoogleLoginCustomer(action) {
	try {
		const response = yield call(api_googleLogin, action.args);

		UserSession.initWithJson(response);

		yield put(loginSuccessAction(response, 'Welcome back ' + UserSession.getName()));

		// Goto profile page after successful login
		//createBrowserHistory().push("/profile");
		//window.location.reload();
	} catch (error) {
		let msg = error;
		if (msg === 'One or more validation errors occurred.') msg = t('customer_register_email_exists');

		yield put(authErrorAction(msg));
	}
}

function* FacebookLoginCustomer(action) {
	try {
		const response = yield call(api_facebookLogin, action.args);

		UserSession.initWithJson(response);

		yield put(loginSuccessAction(response, 'Welcome back ' + UserSession.getName()));

		// Goto profile page after successful login
		//createBrowserHistory().push("/profile");
		//window.location.reload();
	} catch (error) {
		let msg = error;
		console.log(msg);
		if (msg === 'One or more validation errors occurred.') msg = t('customer_register_email_exists');

		yield put(authErrorAction(msg));
	}
}

function* logoutCustomer() {
	try {
		let args = {
			at: UserSession.getAccessToken(),
			rt: UserSession.getRefreshToken()
		};

		UserSession.clearData();

		if (args.at != null && args.rt != null) {
			const response = yield call(api_logout, args);
			yield put(logoutSuccessAction(response));
		}
	} catch (error) {
		yield put(authErrorAction(error));
	} finally {
		// Goto home page
		createBrowserHistory().push('/');
		window.location.reload();
	}
}

function* authSaga() {
	yield takeLatest('login', loginCustomer);
	yield takeLatest('google-login', GoogleLoginCustomer);
	yield takeLatest('facebook-login', FacebookLoginCustomer);
	yield takeEvery('logout', logoutCustomer);
}

export default authSaga;
